export const ListQueryKey = 'banners';
export const DetailQueryKey = 'banner';

export const Urls = {
  selectUrl: '/banner/list',
  updateUrl: '/banner/update',
  deleteUrl: '/banner/delete',
  createUrl: '/banner/create',
  detailUrl: '/banner/detail',
};
